import { render, staticRenderFns } from "./createcheckAct.vue?vue&type=template&id=23c082d2&scoped=true"
import script from "./createcheckAct.vue?vue&type=script&lang=js"
export * from "./createcheckAct.vue?vue&type=script&lang=js"
import style0 from "./createcheckAct.vue?vue&type=style&index=0&id=23c082d2&prod&lang=scss&scoped=true"
import style1 from "./createcheckAct.vue?vue&type=style&index=1&id=23c082d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c082d2",
  null
  
)

export default component.exports